<template>
  <div>
    <m-geo-count />

    <m-content :title="dataSource.Description">
      <b-link @click="$root.$emit('bv::show::modal', 'sampleExample')"
              v-show="$route.name === 'summary'"
              slot="title-right">
        <h3 class="sample">Sample Output Example</h3>
      </b-link>
      <div class="box">
        <div class="the-slide" v-show ="this.$route.name !== 'success'">
          <m-slide />
        </div>
        <div class="the-content">
          <keep-alive v-if="!$route.meta.keepUnAlive">
            <router-view/>
          </keep-alive>
          <router-view v-if="$route.meta.keepUnAlive"></router-view>
        </div>
      </div>
    </m-content>
  </div>

</template>

<script>
  import MContent from '@/components/layouts/MContent'
  import MGeoCount from '@/components/Geo/MGeoCount.vue'
  import MSlide from '@/components/slide/MSlide.vue'

  export default {
    components: {
      MContent,
      MGeoCount,
      MSlide
    },
    data () {
      return {
      }
    },
    computed: {
      dataSource () {
        return this.$store.getters['config/datasource']
      },
      recommendDemos () {
        return this.$store.state.demo.recommendDemos || []
      },
      getCountId () {
        return this.$store.state.summary.getCountId || false
      }
    },
    watch: {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
  .box {
    display: flex;
    flex-wrap: nowrap;
  }
  .the-slide {
    width: 20%;
    max-width: 400px;
    margin-right: 24px;
    background: $color-background;

    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: .25rem;
    padding: 16px;
  }
  .the-content {
    width: 100%;
    flex-grow: 0;
  }

  @media(max-width: 768px) {
    .the-slide {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/Order1.vue